import { colors } from '@/styles/theme';

// Porvenix onboarding brand palette (primary blue), kept explicit so the splash
// renders the same regardless of the user's light/dark preference — it is a
// branded, always-dark welcome screen. Mirrors app theme tokens (accent.blue / bg.*.dark).
export const BRAND = {
  // Was amber (#e8b046/#c98a12) under blue-labeled keys — a leftover from the
  // warm-redesign phase that predates the "swap CTA accent back to blue"
  // change (mui-theme.ts primary). Now matches that same dark-mode primary
  // (main #3b82f6 / dark #2563eb) so the splash's icon/dots/CTA/lang-toggle
  // agree with the rest of the app instead of a stray amber leak.
  blue: colors.primary.dark, // primary.main (dark theme)
  blueBright: colors.info.main, // info.main / accent.blue.dark — distinct lighter accent, unchanged
  blueDark: colors.primary.light, // primary.dark (dark theme) — hover/active state
  green: colors.success.main, // success accent (used in the demo win state / confetti)
  gold: colors.accent.amber.dark,
  // Real Porvenix Yes/No outcome pill tokens (mirror theme success.*/error.* used
  // by TradeButtons) so the demo ticket matches the live market-card UI.
  yesBg: 'rgba(78, 195, 138, 0.15)',
  yesBorder: 'rgba(78, 195, 138, 0.3)',
  yesText: colors.success.main,
  noBg: 'rgba(224, 102, 79, 0.15)',
  noBorder: 'rgba(224, 102, 79, 0.3)',
  noText: colors.error.main,
  bg: colors.bg.primary.dark, // background.default (dark)
  card: colors.bg.secondary.dark, // background.paper (dark)
  cardRow: 'rgba(255, 255, 255, 0.035)',
  cardRowBorder: 'rgba(255, 255, 255, 0.06)',
  textPrimary: colors.neutral[50],
  textSecondary: 'rgba(255, 255, 255, 0.62)',
  textMuted: 'rgba(255, 255, 255, 0.45)',
  cardBorder: 'rgba(255, 255, 255, 0.07)',
} as const;
